import styled from 'styled-components';

export const DescriptionArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 12px;

  > h4 {
    font-family: Manrope, sans-serif;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 2%;
    color: #000;
  }
`;

export const ListDescriptions = styled.ul`
  margin: 12px 0 0 24px;
  list-style: disc;
  > li {
    margin-bottom: 6px;
    color: var(--escala-de-cinza-90, #101010);
    font-family: Manrope, sans-serif;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 3%;
  }
`;

export const LastMessageDescription = styled.p`
  font-family: Manrope, sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 3%;
  vertical-align: middle;
  color: #858585;
  margin: 18px 0 24px 0;
`;
